// imports section Start
import React from "react";
import { Snackbar, Alert, useMediaQuery } from "@mui/material";
// imports section End

const SnackbarMessage = ({ open, handleClose, message, severity }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Snackbar
      open={open}
      autoHideDuration={isMobile ? 4000 : 5000}
      onClose={handleClose}
      // anchorOrigin={{ vertical: "top", horizontal: "right" }}

      anchorOrigin={{
        vertical: isMobile ? "bottom" : "top",
        horizontal: isMobile ? "right" : "right",
      }}
    >
      <Alert onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarMessage;
